import React from 'react';
import { Link } from 'react-router-dom';

class MainBanner extends React.Component {
    render(){
        return (
            <div className="page-title-area item-bg3">
                <div className="container">
                    <h1>Tickets</h1>
                    <span>Get Your Tickets</span>
                    <ul>
                        <li><Link to="/">Home</Link></li>
                        <li>Tickets</li>
                    </ul>
                </div>
            </div>
        );
    }
}
 
export default MainBanner;